import React from 'react'
import { useStaticQuery, graphql } from "gatsby";


export const MenuPath = (id) => {
  const data = useStaticQuery(graphql`
    query {
	  allStrapiAllMenus {
	    edges {
	      node {
	        URL
	        Alias
	        Sub_Parent {
	          Alias
	          URL
	          id
	        }
	        Main_Parent {
	          Alias
	          URL
	          id
	        }
	        Link_Type
	        id
	        strapiId
	      }
	    }
	  }
    }
  `);

	let PageURL = data.allStrapiAllMenus.edges.filter(item => item.node.strapiId === id).pop()?.node;


 	let URL = ''

	if(PageURL) {
  	if((PageURL.Main_Parent != null) &&(PageURL.Sub_Parent != null)) {
    	URL =PageURL.Sub_Parent.URL
  	}
	}


	return URL;

}